import React from 'react';
import { useField } from 'formik';
import Asterisk from '@atoms/Asterisk';
import { ErrorText, Label, FormLabel, FormInput } from '@styled';

export const FormikInput = ({ label, ...props }) => {
    const [field, meta] = useField(props);

    return (
        <Label className="mb-3 mb-md-2" htmlFor={props.id || props.name}>
            {meta.touched && meta.error ? (
                <FormLabel>
                    <ErrorText>{meta.error}</ErrorText>
                </FormLabel>
            ) : (
                <FormLabel>
                    {props.required ? (
                        <>
                            {label}
                            <Asterisk />
                        </>
                    ) : (
                        <>{label}</>
                    )}
                </FormLabel>
            )}
            <FormInput {...field} {...props} />
        </Label>
    );
};

export const FormikRadio = ({ label, ...props }) => {
    const [field, meta] = useField(props);

    return (
        <label className="mb-3 mb-md-2" htmlFor={props.id || props.name}>
            <input className="mr-2" {...field} {...props} />
            <span className="d-inline-block mr-3">{label}</span>
        </label>
    );
};

export const FormikSelectSimple = ({ label, ...props }) => {
    const [field, meta] = useField(props);

    return (
        <>
            <select {...field} {...props} />
            {meta.touched && meta.error ? <div className="error">{meta.error}</div> : null}
        </>
    );
};
